/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import * as React from 'react';
import translate from '../../services/i18n/translate';

const HelpPage: React.FunctionComponent = () => {
  return (
    <div className="component-inner gdpr" id="HelpPage">
      <h3 id="HelpPage_title">{translate['help.title']}</h3>
      <div className="gdpr-container">
        <div className="clean-text" id="HelpPage_text">
          {translate['help.text']}
        </div>
      </div>
    </div>
  );
};

export default HelpPage;
